import { faEnvelope } from "@fortawesome/fontawesome-free-regular";
import {
  faFlagCheckered,
  faMapPin,
  faMoneyBill,
  faPhone,
} from "@fortawesome/fontawesome-free-solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import emailjs from "emailjs-com";
import React, { useState, useEffect } from "react";
import RSelect from "react-select";
import swal from "sweetalert";
import "../../../components/Styles/FormStyle.css";
import "../../../components/Styles/SecondPage.css";
import { secret } from "../data";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal2);

const SecondPage = (props) => {
  const [loading, setLoading] = useState(true);
  const [clientLocalization, setClientLocalization] = useState(
    props.userLocalization
  );
  const [clientExpectations, setClientExpectations] = useState(
    props.userExpectations
  );
  const [clientName, setClientName] = useState(props.userName);
  const [clientPhone, setClientPhone] = useState(props.userPhone);
  const [clientMail, setClientMail] = useState(props.userMail);
  const [clientAcceptPolicy, setClientAcceptPolicy] = useState(true);
  const [blog, setBlog] = useState([]);

  const fetchBlog = async () => {
    await fetch(`https://twojeskd.pl/wp-json/wp/v2/posts?per_page=100`)
      .then((response) => response.json())
      .then((data) => {
        fetchBlogMedia(data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const fetchBlogMedia = async (posts) => {
    await fetch(`https://twojeskd.pl/wp-json/wp/v2/media?per_page=100`)
      .then((response) => response.json())
      .then((data) => {
        var arr = [];
        posts.forEach((post) => {
          var newR = {
            date: post.date,
            description: post.description,
            link: post.link,
            title: post.title,
            content: post.content.rendered,
            linkMedia:
              data.filter((el) => el.id === post.featured_media).length > 0
                ? data.filter((el) => el.id === post.featured_media)[0]
                    .source_url
                : "",
          };
          arr.push(newR);
        });
        setBlog(arr);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    fetchBlog();
  }, []);

  const changeClientLocalization = (e) => {
    setClientLocalization(e.value);
    props.onChangeUserLocalization(e);
  };

  const changeClientExpectations = (e) => {
    setClientExpectations(e.target.value);
    props.onChangeUserExpectations(e);
  };

  const changeClientName = (e) => {
    setClientName(e.target.value);
    props.onChangeUserName(e);
  };

  const changeClientPhone = (e) => {
    setClientPhone(e.target.value);
    props.onChangeUserPhone(e);
  };

  const changeClientMail = (e) => {
    setClientMail(e.target.value);
    props.onChangeUserMail(e);
  };

  const changeClientAcceptPolicy = (e) => {
    setClientAcceptPolicy(e.target.checked);
  };

  const validateForm = () => {
    var phoneno = /^[0-9]{9}$/;
    var phoneCheck = phoneno.test(clientPhone);
    if (
      !clientLocalization ||
      !clientExpectations ||
      !clientName ||
      !clientPhone ||
      !clientMail ||
      !phoneCheck
    ) {
      return false;
    } else {
      props.changeValidate(2);
      return true;
    }
  };

  const fillRequiredFieldsAlert = () => {
    var phoneno = /^[0-9]{9}$/;
    var phoneCheck = phoneno.test(clientPhone);
    var txt = ``;
    if (!clientLocalization) {
      txt = txt + "Lokalizacja \n";
    }
    if (!clientExpectations) {
      txt = txt + "Oczekiwania względem oferty \n";
    }
    if (!clientName) {
      txt = txt + "Imię i nazwisko \n";
    }
    if (!clientPhone) {
      txt = txt + "Numer telefonu \n";
    }
    if (!clientMail) {
      txt = txt + "Adres e-mail \n";
    }

    return txt;
  };

  const generateCode = () => {
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < 5) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  };

  const sendSMSCode = async (code) => {
    var body = {
      phone: clientPhone,
      message: `Wprowadź kod: ${code} aby zobaczyć oferty kancelarii zajmujących się tematyką SKD.`,
    };

    await fetch("https://api.twojeskd.pl/send_sms_tskd", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secret,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {})
      .catch((error) => {});
  };

  const submitSecondForm = (e) => {
    var requiredFields = fillRequiredFieldsAlert();
    if (validateForm()) {
      var code = generateCode();
      sendSMSCode(code);
      MySwal.fire({
        title: "UWAGA",
        input: "text",
        inputLabel: "wprowadź kod otrzymany w SMS",
        showCancelButton: true,
        cancelButtonText: "Anuluj",
        confirmButtonText: "Pokaż kancelarie",
        cancelButtonColor: "#131e3d",
        inputValidator: (value) => {
          if (value !== code) {
            return "wprowadzony kod jest nieprawidłowy";
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          props.onSubmitSecondForm(e);
          sendWelcomeMail();
        }
      });
    } else {
      swal({
        icon: "error",
        text: `Należy uzupełnić wymagane pola formularza!
                      \n
                      ${requiredFields}
                      `,
        button: {
          text: "Ok",
        },
      });
    }
  };

  const submitDetailsAnalysis = (e) => {
    var requiredFields = fillRequiredFieldsAlert();
    if (validateForm()) {
      var code = generateCode();
      sendSMSCode(code);
      MySwal.fire({
        title: "UWAGA",
        input: "text",
        inputLabel: "wprowadź kod otrzymany w SMS",
        showCancelButton: true,
        cancelButtonText: "Anuluj",
        confirmButtonText: "Przejdź do generowania analizy SKD",
        cancelButtonColor: "#131e3d",
        inputValidator: (value) => {
          if (value !== code) {
            return "wprowadzony kod jest nieprawidłowy";
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          props.onClickDetailsAnalysis(e);
          sendWelcomeMail();
        }
      });
    } else {
      swal({
        icon: "error",
        text: `Należy uzupełnić wymagane pola formularza!
                      \n
                      ${requiredFields}
                      `,
        button: {
          text: "Ok",
        },
      });
    }
  };

  const focus = (e) => {
    e.target.select();
  };

  const sendWelcomeMail = () => {
    window.fbq("trackCustom", "contactPorSKD");
    window.gtag("event", "conversion", {
      send_to: "AW-11435982333/dqjoCPaGidsZEP37jM0q",
    });

    emailjs.init("user_7x2uGk2osoyVegzDMAi4G");
    var templateParams = {
      name: clientName,
      mail: clientMail,
    };

    emailjs.send("TwojeSKD", "template_71oct28", templateParams).then(
      function (response) {},
      function (error) {}
    );
  };

  const regionList = [
    "Dolnośląskie",
    "Kujawsko-Pomorskie",
    "Lubelskie",
    "Lubuskie",
    "Łódzkie",
    "Małopolskie",
    "Mazowieckie",
    "Opolskie",
    "Podkarpackie",
    "Podlaskie",
    "Pomorskie",
    "Śląskie",
    "Świętokrzyskie",
    "Warmińsko-Mazurskie",
    "Wielkopolskie",
    "Zachodniopomorskie",
  ];

  const decodeHtml = (html) => {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  return (
    <>
      <div className="mainContainerSecond">
        <div className="contentSecond">
          <div className="formContainerSecond">
            <div className="rowSecond">
              <div className="twoColSecond">
                <div className="oneCol_columnSecond">
                  <div className="formTitleSecond">
                    <label htmlFor="bankChoose">
                      Wybierz województwo
                      <span className="requiredStar">*</span>
                    </label>
                  </div>
                  <RSelect
                    className="currencySelect"
                    value={clientLocalization}
                    onChange={changeClientLocalization}
                    options={regionList.map((region) => ({
                      value: region,
                      key: region,
                      label: (
                        <>
                          <img
                            src="https://twojeskd.pl/wp-content/uploads/2023/12/select_region.png"
                            width="20px"
                            className="imgSelect"
                          />
                          <span className="selectInside">{region}</span>
                        </>
                      ),
                    }))}
                    placeholder={
                      clientLocalization
                        ? clientLocalization
                        : "Wybierz z listy..."
                    }
                  />
                </div>
                <div className="formSepSecond"></div>
                <div className="oneCol_columnSecond">
                  <div className="formTitleSecond">
                    <label htmlFor="bankChoose">
                      Co jest dla Ciebie wazne?
                      <span className="requiredStar">*</span>
                    </label>
                  </div>
                  <div className="chooseExpectationsBoxSecond">
                    <button
                      className={
                        clientExpectations === "Ilość wygranych spraw"
                          ? "expectationsPointSecondActive"
                          : "expectationsPointSecond"
                      }
                      onClick={changeClientExpectations}
                      value="Ilość wygranych spraw"
                    >
                      <FontAwesomeIcon icon={faFlagCheckered} />
                      Ilość wygranych
                    </button>
                    <button
                      className={
                        clientExpectations === "Lokalizacja"
                          ? "expectationsPointSecondActive"
                          : "expectationsPointSecond"
                      }
                      onClick={changeClientExpectations}
                      value="Lokalizacja"
                    >
                      <FontAwesomeIcon icon={faMapPin} />
                      Lokalizacja
                    </button>
                    <button
                      className={
                        clientExpectations === "Cena"
                          ? "expectationsPointSecondActive"
                          : "expectationsPointSecond"
                      }
                      onClick={changeClientExpectations}
                      value="Cena"
                    >
                      <FontAwesomeIcon icon={faMoneyBill} />
                      Cena
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="rowSep" />
            <div className="rowSecond">
              <div className="formTitleASecond">
                <label htmlFor="bankChoose">
                  Dane kontaktowe kredytobiorcy
                  <span className="requiredStar">*</span>
                </label>
              </div>
              <div className="twoColSecond">
                <div className="oneColA_columnSecond">
                  <input
                    type="text"
                    id={clientName ? "userName" : "requiredInput"}
                    name="userName"
                    placeholder="Imię i nazwisko"
                    value={clientName}
                    onChange={changeClientName}
                    onFocus={focus}
                  />
                </div>
              </div>
              <div id="twoColSecond_spec" className="twoColSecond">
                <div className="twoCol_columnASecond">
                  <input
                    type="text"
                    id={clientPhone ? "userPhone" : "requiredInput"}
                    name="userPhone"
                    placeholder="Numer telefonu"
                    value={clientPhone}
                    onChange={changeClientPhone}
                    onFocus={focus}
                  />
                </div>
                <div className="twoCol_columnASecond">
                  <input
                    type="text"
                    id={clientMail ? "userMail" : "requiredInput"}
                    name="userMail"
                    placeholder="Adres e-mail"
                    value={clientMail}
                    onChange={changeClientMail}
                    onFocus={focus}
                  />
                </div>
              </div>
              <div className="twoColSecond">
                <div className="oneColB_columnSecond">
                  <label className="containerPrivacyBox">
                    Oświadczam, że zapoznałem się z{" "}
                    <a
                      className="linkHref"
                      href="https://twojeskd.pl/polityka-prywatnosci/"
                      target="_blank"
                    >
                      Polityką prywatności
                    </a>{" "}
                    oraz akceptuje jej postanowienia i wyrażam zgodę na kontakt
                    kancelarii w niej wymienionych.
                    <span className="requiredStar">*</span>
                    <input
                      type="checkbox"
                      checked={clientAcceptPolicy}
                      onClick={changeClientAcceptPolicy}
                    />
                    <span className="checkmarkPrivacyBox"></span>
                  </label>

                  {clientAcceptPolicy ? (
                    <div className="buttonsBoxSecondPage">
                      <button
                        className="analysisTriggerBox"
                        onClick={submitDetailsAnalysis}
                        disabled={!clientAcceptPolicy}
                      >
                        <div className="analysisTriggerBoxDescSection">
                          <p className="analysisTriggerBoxDescSectionTitle">
                            WYKONAJ ANALIZĘ
                          </p>
                          <p className="analysisTriggerBoxDescSectionDesc">
                            i przejdź do ofert kancelarii SKD
                          </p>
                        </div>
                      </button>

                      <button
                        className="comparerTriggerBox"
                        onClick={submitSecondForm}
                        disabled={!clientAcceptPolicy}
                      >
                        <div className="analysisTriggerBoxDescSection">
                          <p
                            className="analysisTriggerBoxDescSectionTitle"
                            style={{ color: "#505A53" }}
                          >
                            PORÓWNAJ OFERTY
                          </p>
                          <p
                            className="analysisTriggerBoxDescSectionDesc"
                            style={{ color: "#505A53" }}
                          >
                            i wybierz swoją kancelarię SKD
                          </p>
                        </div>
                      </button>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="rowSecond">
              <div className="twoColSecond">
                <div className="twoCol_columnSecond">
                  <button
                    className="submitButtonSecondPage"
                    onClick={props.onClickPrevoiusPage}
                  >
                    ← Wstecz
                  </button>
                </div>
              </div>
            </div>
            <div className="rowSecondMobile">
              <div className="contact_first_page">
                <div className="contact_first_page_box1">
                  <img
                    className="contact_first_page_ico"
                    src="https://twojeskd.pl/wp-content/uploads/2023/12/first_page_2.png"
                  />
                </div>
                <div className="contact_first_page_box2">
                  <p className="contact_first_page_title">
                    Potrzebujesz pomocy?
                  </p>
                  <p className="contact_first_page_desc">
                    Karolina chętnie Ci pomoże
                  </p>
                  <div className="contact_first_page_details_box">
                    <div className="contact_first_page_details_col">
                      <div className="contactIco">
                        <FontAwesomeIcon icon={faPhone} />
                      </div>
                      +48 530 325 400
                    </div>
                    <div className="contact_first_page_details_col">
                      <div className="contactIco">
                        <FontAwesomeIcon icon={faEnvelope} />
                      </div>
                      <a
                        href="mailto: biuro@twojeskd.pl"
                        style={{ color: "#505A53", textDecoration: "none" }}
                      >
                        biuro@twojeskd.pl
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="oneColFirst_column_additional2"
                className="twoCol_columnFirst"
                style={{ display: "block", boxSizing: "border-box" }}
              >
                <p className="pBlog" style={{ margin: "0", fontWeight: "600" }}>
                  Najnowsze na blogu
                </p>
                {loading ? (
                  <p className="pBlog">Ładowanie artykułów...</p>
                ) : (
                  <div>
                    <a
                      style={{ textDecoration: "none", color: "black" }}
                      target="_blank"
                      href={blog.length > 0 ? blog[0].link : ""}
                    >
                      <p className="pBlog">
                        {decodeHtml(
                          blog.length > 0 ? blog[0].title.rendered : ""
                        )}{" "}
                        <span
                          className="pBlog"
                          style={{
                            fontWeight: "600",
                            margin: "0",
                          }}
                        >
                          →
                        </span>
                      </p>
                    </a>
                    <a
                      style={{ textDecoration: "none", color: "black" }}
                      target="_blank"
                      href={blog.length > 0 ? blog[1].link : ""}
                    >
                      <p className="pBlog">
                        {decodeHtml(
                          blog.length > 0 ? blog[1].title.rendered : ""
                        )}{" "}
                        <span
                          className="pBlog"
                          style={{
                            fontWeight: "600",
                            margin: "0",
                          }}
                        >
                          →
                        </span>
                      </p>
                    </a>
                    <a
                      style={{ textDecoration: "none", color: "black" }}
                      target="_blank"
                      href={blog.length > 0 ? blog[2].link : ""}
                    >
                      <p className="pBlog">
                        {decodeHtml(
                          blog.length > 0 ? blog[2].title.rendered : ""
                        )}{" "}
                        <span
                          className="pBlog"
                          style={{
                            fontWeight: "600",
                            margin: "0",
                          }}
                        >
                          →
                        </span>
                      </p>
                    </a>
                    <a
                      style={{ textDecoration: "none", color: "black" }}
                      target="_blank"
                      href={blog.length > 0 ? blog[3].link : ""}
                    >
                      <p className="pBlog">
                        {decodeHtml(
                          blog.length > 0 ? blog[3].title.rendered : ""
                        )}{" "}
                        <span
                          className="pBlog"
                          style={{
                            fontWeight: "600",
                            margin: "0",
                          }}
                        >
                          →
                        </span>
                      </p>
                    </a>
                    <a
                      style={{ textDecoration: "none", color: "black" }}
                      target="_blank"
                      href={blog.length > 0 ? blog[4].link : ""}
                    >
                      <p className="pBlog">
                        {decodeHtml(
                          blog.length > 0 ? blog[4].title.rendered : ""
                        )}{" "}
                        <span
                          className="pBlog"
                          style={{
                            fontWeight: "600",
                            margin: "0",
                          }}
                        >
                          →
                        </span>
                      </p>
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="descContainerSecond">
            <div style={{ height: "5vh" }}></div>
            <div className="contact_first_page">
              <div className="contact_first_page_box1">
                <img
                  className="contact_first_page_ico"
                  src="https://twojeskd.pl/wp-content/uploads/2023/12/first_page_2.png"
                />
              </div>
              <div className="contact_first_page_box2">
                <p className="contact_first_page_title">Potrzebujesz pomocy?</p>
                <p className="contact_first_page_desc">
                  Karolina chętnie Ci pomoże
                </p>
                <div className="contact_first_page_details_box">
                  <div className="contact_first_page_details_col">
                    <div className="contactIco">
                      <FontAwesomeIcon icon={faPhone} />
                    </div>
                    +48 530 325 400
                  </div>
                  <div className="contact_first_page_details_col">
                    <div className="contactIco">
                      <FontAwesomeIcon icon={faEnvelope} />
                    </div>
                    <a
                      href="mailto: biuro@twojeskd.pl"
                      style={{ color: "#505A53", textDecoration: "none" }}
                    >
                      biuro@twojeskd.pl
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="oneColFirst_column_additional2"
              className="twoCol_columnFirst"
              style={{ display: "block", boxSizing: "border-box" }}
            >
              <p className="pBlog" style={{ margin: "0", fontWeight: "600" }}>
                Najnowsze na blogu
              </p>
              {loading ? (
                <p className="pBlog">Ładowanie artykułów...</p>
              ) : (
                <div>
                  <a
                    style={{ textDecoration: "none", color: "black" }}
                    target="_blank"
                    href={blog.length > 0 ? blog[0].link : ""}
                  >
                    <p className="pBlog">
                      {decodeHtml(
                        blog.length > 0 ? blog[0].title.rendered : ""
                      )}{" "}
                      <span
                        className="pBlog"
                        style={{
                          fontWeight: "600",
                          margin: "0",
                        }}
                      >
                        →
                      </span>
                    </p>
                  </a>
                  <a
                    style={{ textDecoration: "none", color: "black" }}
                    target="_blank"
                    href={blog.length > 0 ? blog[1].link : ""}
                  >
                    <p className="pBlog">
                      {decodeHtml(
                        blog.length > 0 ? blog[1].title.rendered : ""
                      )}{" "}
                      <span
                        className="pBlog"
                        style={{
                          fontWeight: "600",
                          margin: "0",
                        }}
                      >
                        →
                      </span>
                    </p>
                  </a>
                  <a
                    style={{ textDecoration: "none", color: "black" }}
                    target="_blank"
                    href={blog.length > 0 ? blog[2].link : ""}
                  >
                    <p className="pBlog">
                      {decodeHtml(
                        blog.length > 0 ? blog[2].title.rendered : ""
                      )}{" "}
                      <span
                        className="pBlog"
                        style={{
                          fontWeight: "600",
                          margin: "0",
                        }}
                      >
                        →
                      </span>
                    </p>
                  </a>
                  <a
                    style={{ textDecoration: "none", color: "black" }}
                    target="_blank"
                    href={blog.length > 0 ? blog[3].link : ""}
                  >
                    <p className="pBlog">
                      {decodeHtml(
                        blog.length > 0 ? blog[3].title.rendered : ""
                      )}{" "}
                      <span
                        className="pBlog"
                        style={{
                          fontWeight: "600",
                          margin: "0",
                        }}
                      >
                        →
                      </span>
                    </p>
                  </a>
                  <a
                    style={{ textDecoration: "none", color: "black" }}
                    target="_blank"
                    href={blog.length > 0 ? blog[4].link : ""}
                  >
                    <p className="pBlog">
                      {decodeHtml(
                        blog.length > 0 ? blog[4].title.rendered : ""
                      )}{" "}
                      <span
                        className="pBlog"
                        style={{
                          fontWeight: "600",
                          margin: "0",
                        }}
                      >
                        →
                      </span>
                    </p>
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SecondPage;
